<template>
  <div v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('document-type.defaultDocumentStatus')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownDocumentStatuses"
            :selected-item="selectedDocumentStatus"
            @update:selected="handleDocumentStatusSelection"
            name="defaultDocumentStatus"
            :mode="mode"
            clearable />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.defaultPaymentType')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownPaymentTypes"
            :selected-item="selectedPaymentType"
            @update:selected="handlePaymentTypeSelection"
            name="defaultPaymentType"
            :mode="mode"
            clearable />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.requirePaymentType')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.requirePaymentType"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="requirePaymentType" v-model="data.requirePaymentType" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.defaultDeliveryType')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownDeliveryTypes"
            :selected-item="selectedDeliveryType"
            @update:selected="handleDeliveryTypeSelection"
            name="defaultDeliveryType"
            :mode="mode"
            clearable />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.reportingTemplate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownReportingTemplates"
            :selected-item="selectedReportingTemplate"
            @update:selected="handleReportingTemplateSelection"
            name="defaultReportingTemplate"
            :mode="mode"
            clearable />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.requireDeliveryType')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.requireDeliveryType"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="requireDeliveryType" v-model="data.requireDeliveryType" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.requireWarehouse')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.requireWarehouse"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="requireWarehouse" v-model="data.requireWarehouse" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowManualPrices')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowManualPrices"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="allowManualPrices" v-model="data.allowManualPrices" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowZeroValues')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowZeroValues"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="allowZeroValues" v-model="data.allowZeroValues" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowZeroQty')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowZeroQty"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="allowZeroQty" v-model="data.allowZeroQty" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowDynamicRange')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowDynamicRange"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="allowDynamicRange" v-model="data.allowDynamicRange" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowHeaderDiscounts')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowHeaderDiscounts"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="allowHeaderDiscounts" v-model="data.allowHeaderDiscounts" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.allowEditClosedDocuments')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.allowEditClosedDocuments"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle
            v-else
            name="allowEditClosedDocuments"
            v-model="data.allowEditClosedDocuments" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('document-type.maxDetailUnitPrice')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.maxDetailUnitPrice"
            color="base"
            flat
            type="number"
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="maxDetailUnitPriceErrorMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('document-type.maxDetailQty')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.maxDetailQty"
            color="base"
            flat
            type="number"
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="maxDetailQtyErrorMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('document-type.daysToDelivery')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.daysToDelivery"
            color="base"
            flat
            type="number"
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="daysToDeliveryErrorMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('document-type.totalMeasurementUnits')"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.totalMeasurementUnits"
            color="base"
            flat
            type="number"
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="totalMeasurementUnitsMessage" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.takeDigitalSignature')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.takeDigitalSignature"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="takeDigitalSignature" v-model="data.takeDigitalSignature" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.mergedSameDocumentLines')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.mergedSameDocumentLines"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle
            v-else
            name="mergedSameDocumentLines"
            v-model="data.mergedSameDocumentLines" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.usePaymentTypes')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.usePaymentTypes"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="usePaymentTypes" v-model="data.usePaymentTypes" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.supportLoyalty')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.supportLoyalty"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="supportLoyalty" v-model="data.supportLoyalty" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('document-type.syncWithMyData')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus
            v-if="mode == 'view'"
            :item="data.syncWithMyData"
            :textTrue="$t('common.actions.yes')"
            :textFalse="$t('common.actions.no')" />
          <BaseToggle v-else name="syncWithMyData" v-model="data.syncWithMyData" />
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseToggle from '../common/BaseToggle.vue';
import BaseSelectDropdown from '../common/BaseSelectDropdown.vue';
import type { DocumentType } from '@/types/DocumentTypes';
import { onMounted, ref, watch } from 'vue';
import { useLookupsStore } from '@/stores/lookups';
import { storeToRefs } from 'pinia';
import type { SelectDropdownItem } from '@/types/Base';
import BaseInput from '../common/BaseInput.vue';

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
  maxDetailUnitPriceErrorMessage: string;
  maxDetailQtyErrorMessage: string;
  daysToDeliveryErrorMessage: string;
  totalMeasurementUnitsMessage: string;
}>();

const {
  getDocumentStatusesLookup,
  getPaymentTypesLookup,
  getDeliveryTypesLookup,
  getReportingTemplatesLookup,
} = useLookupsStore();

const {
  dropdownDocumentStatuses,
  dropdownPaymentTypes,
  dropdownDeliveryTypes,
  dropdownReportingTemplates,
} = storeToRefs(useLookupsStore());

const data = defineModel<DocumentType>();

const selectedDocumentStatus = ref<SelectDropdownItem | null>(null);
const selectedPaymentType = ref<SelectDropdownItem | null>(null);
const selectedDeliveryType = ref<SelectDropdownItem | null>(null);
const selectedReportingTemplate = ref<SelectDropdownItem | null>(null);

watch(
  () => data.value,
  () => {
    initDropdowns();
  }
);

onMounted(async () => {
  await getDocumentStatusesLookup();
  await getPaymentTypesLookup();
  await getDeliveryTypesLookup();
  await getReportingTemplatesLookup();

  initDropdowns();
});

function initDropdowns() {
  if (data.value) {
    const documentStatusValue = dropdownDocumentStatuses.value.find(
      (item) => item.value == data.value?.defaultDocumentStatusID
    );
    if (documentStatusValue) selectedDocumentStatus.value = documentStatusValue;

    const paymentTypeValue = dropdownPaymentTypes.value.find(
      (item) => item.value == data.value?.defaultPaymentTypeID
    );
    if (paymentTypeValue) selectedPaymentType.value = paymentTypeValue;

    const deliveryTypeValue = dropdownDeliveryTypes.value.find(
      (item) => item.value == data.value?.defaultDeliveryTypeID
    );
    if (deliveryTypeValue) selectedDeliveryType.value = deliveryTypeValue;
  }

  const reportingTemplate = dropdownReportingTemplates.value.find(
    (item) => item.value == data.value?.defaultReportingTemplateId
  );
  if (reportingTemplate) selectedReportingTemplate.value = reportingTemplate;
}

function handleDocumentStatusSelection(item: SelectDropdownItem) {
  if (!data.value) return;
  selectedDocumentStatus.value = item ? item : null;
  data.value.defaultDocumentStatusID = item ? item.value.toString() : '';
}

function handlePaymentTypeSelection(item: SelectDropdownItem) {
  if (!data.value) return;
  selectedPaymentType.value = item ? item : null;
  data.value.defaultPaymentTypeID = item ? item.value.toString() : '';
}

function handleDeliveryTypeSelection(item: SelectDropdownItem) {
  if (!data.value) return;

  selectedDeliveryType.value = item ? item : null;
  data.value.defaultDeliveryTypeID = item ? item.value.toString() : '';
}

function handleReportingTemplateSelection(item: SelectDropdownItem) {
  if (!data.value) return;
  selectedReportingTemplate.value = item ? item : null;
  data.value.defaultReportingTemplateId = item ? item.value.toString() : '';
}
</script>
